// @flow
import * as React from 'react';
import classNames from 'classnames';
import Store from '../store/Store';
import StoreListener from '../store/StoreListener';
import { TOAST } from '../store/Constants';
import Button from './Button';

import './Toast.css';
import t from '../i18n/I18n';

type Props = {
  TOAST: Object
};

type State = {
  timeout: number,
  hiding: boolean
};

const storeItems = [TOAST];

@StoreListener(storeItems)
export default class Toast extends React.Component<Props, State> {
  _toastTimer: any;
  state = {
    timeout: 0,
    hiding: false
  };

  componentDidUpdate(prevProps: Props) {
    const toast = this.props[TOAST];
    const prevToast = prevProps[TOAST];
    if (toast && toast !== prevToast) {
      clearTimeout(this._toastTimer);
      let timeout = toast.length * 100;
      timeout = Math.max(timeout, 2000);
      timeout = Math.min(timeout, 15000);
      this.setState({ timeout });
      this._toastTimer = setTimeout(this.hide, timeout);
    }
  }

  onClick = () => {
    this.hide();
  };

  hide = () => {
    this.setState({ hiding: true, timeout: 0 });
    setTimeout(() => {
      Store.put(TOAST, '');
      this.setState({ hiding: false });
    }, 100);
  };

  render() {
    const toast = this.props[TOAST];
    const { hiding, timeout } = this.state;
    return (
      <div className={'toastWrrper'}>
        <center>
          <div name="Toast" className={classNames('toast', { show: toast && !hiding })}>
            <div className={classNames('message', { 'show-button': timeout > 5000 })}>
              {toast}
              <Button type="PLAIN" text={t('CLOSE')} onClick={this.onClick} />
            </div>
          </div>
        </center>
      </div>
    );
  }
}
